const actionTypeIdentifier = '308AB200-CE2B-4EA7-B5B3-63E1D116C69A'; //this is a newid

export const setLocationSiteError = `SET-LOCATION-SITE-ERROR-${actionTypeIdentifier}`;
export const setLocationSiteLoading = `SET-LOCATION-SITE-LOADING-${actionTypeIdentifier}`;
export const getLocationCountryList = `GET-LOCATION-COUNTRY-LIST-${actionTypeIdentifier}`;
export const setDefaultState = `SET-DEFAULT-STATE-${actionTypeIdentifier}`;

export const locationSiteModel = {
    locationSiteId: ""
    , address1: ""
    , address2: ""
    , countryId: 0
    , countryName: ""
    , countryCode: ""
    , city: ""
    , locationState: ""
    , zip: ""
    , locationType: ""
}